import React, { ComponentPropsWithoutRef } from 'react';
import useFigureStyles from './MarkdownFigure.styles';

type FigureProps = ComponentPropsWithoutRef<'figure'>;

export default function MarkdownFigure({ children }: FigureProps) {
  const {
    classes: { figure },
  } = useFigureStyles();

  return <figure className={figure}>{children}</figure>;
}
